import { DATA_SOURCE_IDS } from '@discover-frontend/constants';

export const supportsSocial = (dataSource?: any) => {
  if (!dataSource) return false;

  return [DATA_SOURCE_IDS.TWITTER, DATA_SOURCE_IDS.INSTAGRAM_FOLLOWS].includes(
    dataSource
  );
};

export const supportsSegmentationAndCompare = (dataSource?: any) => {
  if (!dataSource) return false;

  return [DATA_SOURCE_IDS.TWITTER].includes(dataSource);
};
